import gql from 'graphql-tag';

export const ALL_PLANS = gql`
  query AllPlansQuery {
    me {
      ... on StaffMember {
        id
        practice {
          id
          membershipPlans(first: 15) {
            edges {
              plan: node {
                id
                title
                description
                priceCents
              }
            }
          }
        }
      }
    }
  }
`;
